import React, {useEffect, useState} from "react";
import QrScanner from "qr-scanner";
import {useNavigate} from "react-router-dom";
import Button from "../Button";

import {
    QrCodeIcon,
} from '@heroicons/react/24/outline'

const Qrscan: React.FC = () => {
    const [result, setResult] = useState<string>("");
    const [trialCode, setTrialCode] = useState<string>("");
    const [tap, setTapNumber] = useState<string>("");
    const [error, setError] = useState<string>(""); // State for error messages
    const [scanner, setScanner] = useState<QrScanner | null>(null); // Specify the type for the scanner
    const navigate = useNavigate();

    useEffect(() => {
        // Cleanup function to stop the scanner on unmount
        return () => {
            if (scanner) {
                scanner.stop();
            }
        };
    }, [scanner]);

    useEffect(() => {

        try {
            if (scanner) {
                const video = document.getElementById("qr-video") as HTMLVideoElement;
                if (video) {
                    scanner.start().then(() => {
                        QrScanner.listCameras(true).then((cameras) => {
                            cameras.forEach((camera) => {
                                const option = document.createElement("option");
                                option.value = camera.id;
                                option.text = camera.label;
                                // Here you could populate a camera selection if needed
                            });
                        });
                    });

                    // Handle QR code scanning results
                    if (result !== "") {
                        const appUrl = process.env.REACT_APP_URL as string;
                        const link = result.replace(appUrl, "");

                        const regex = /cart\/([^/]+)\/([^/]+)/;
                        const match = link.match(regex);

                        if (match) {
                            const itemId = match[1]; // 2br45T
                            const quantity = match[2]; // 10

                            console.log("Item ID:", itemId);
                            console.log("Quantity:", quantity);
                        }

                        const parts = link.split("/");
                        setTrialCode(parts[parts.length - 2]); // 2br45T
                        setTapNumber(parts[parts.length - 1]);

                        closeScan();
                        navigate(link);
                    }
                } else {
                    console.error("Video element not found");
                }
            }

        }
        catch (error){
            console.error(error);
            throw error;
        }
    }, [result, navigate, scanner]);

    const startScan = () => {

        const video = document.getElementById("qr-video") as HTMLVideoElement; // Type assertion for video element
        setResult("");

        if (video) {
            const newScanner = new QrScanner(
                video,
                (result: string) => setResult(result), // Handle QR code result
                (error: Error | string) => {
                    // Convert error to string if it is an instance of Error
                    setError(error instanceof Error ? error.message : String(error));
                }
            );
            setScanner(newScanner); // Store the scanner instance
        } else {
            console.error("Video element not found");
        }

    };

    const closeScan = () => {
        if (scanner) {
            scanner.stop(); // Stop the scanner
            setScanner(null); // Clear the scanner instance
        }
    };

    return (
        <>
            {scanner && (
                <>
                    <div className="flex flex-col p-6 justify-end">
                        <Button style="primary" className="mb-0" type="button" onClick={closeScan}>
                            Close
                        </Button>
                    </div>
                </>
            )}

            {!scanner && (
                <div className="p-6 justify-end">
                    <Button style="scan" type="button" onClick={startScan}>
                        <div className={"m-auto"}>
                            <QrCodeIcon height={100} className={"m-auto"}></QrCodeIcon>
                        </div>
                        <div className={"text-2xl mt-3"}>Scan QR Code</div>
                    </Button>
                </div>
            )}

            <div id="video-container" className={"p-6 pt-0"}>
                {result &&
                    <>
                        <p className={'items-center text-center'}>
                            Trial Code: <b>{trialCode}</b>
                        </p>
                        <p className={'items-center text-center'}>
                            Trial Code: <b>{tap}</b>
                        </p>
                        <div className="flex flex-col p-6 justify-end">
                            <p>
                                <a className={"flex w-full pt-6 pb-6 items-center border justify-center rounded-lg bg-primary-btn max-h-11 px-5 py-2.5 text-md font-bold text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300  dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 mb-0"} href={result}>
                                    Open Tap page
                                </a></p>
                        </div>
                    </>
                }
                <video id="qr-video"/>
            </div>
        </>
    );
}

export default Qrscan;
